// 导出consumerProducts的url地址
export const url = {
  // 最热门十大宣称产品形态分布
  // list: '/manage/concept/list',
  // 最热门十大宣称产品市场分类分布
  // segment: '/auth/public/segment_list',
  goodsForms: '/auth/public/get_goodsForms',
  goodsAspects: '/auth/public/get_goodsAspects',
  goodsSpa: '/auth/public/get_goodsSPF',
  goodsPa: '/auth/public/get_goodsPA',
  marketCategory: '/auth/public/get_goodsMarketCategory',
  subCategory: '/auth/public/get_goodsSubCategory',
  searchByLetter: '/auth/claim/searchByFirstLetter',
  getBrandList: '/auth/brand/list',
  getProductList: '/auth/product/productList',
  getDiscriptionList: '/auth/product/productList',
  getTopProductDistributionList: '/auth/product/getTop10ProductDistribution',
  getTopDistributionList: '/auth/product/getProductDistribution',
  getGoodsMarketCategory: '/auth/public/get_goodsMarketCategory',
  /** relatedBasfProduct */
  // getRelatedBasfProduct: '/auth/product/relatedBasfProduct',
  /** 根据产品查详细页 */
  goodsDetail: '/auth/product/detail',
  /** 根据产品查询相似配方 */
  goodsSimilarFormulation: '/auth/product/similarFormulation',
  goodsSimilarFormulationList: '/auth/product/benchmarkFormulation',
  /** 产品列表推荐配方 */
  goodsRecommendFormulation: '/auth/product/recommendFormulation',
  /**   关联BASF产品 */
  goodsRelatedBasfProduct: '/auth/product/relatedBasfProduct',
  /**  产品详情推荐产品 */
  goodsRecommendProduct: '/auth/product/recommendProduct',
  /**  商品详情-推荐商品 */
  goodsInterestingProduct: '/auth/product/interestingProduct',
  /**  商品详情-评论聚合 */
  goodsProductComment: '/auth/product/productComment',
  /** 商品详情-商品点击 */
  goodsProductHit: '/auth/product/productHit',
  /**  商品详情-点击区域 */
  goodsProductHitArea: '/auth/product/productHitArea',
  /**  商品详情-评论区域 */
  goodsProductCommentArea: '/auth/product/productCommentArea',
  /**  品牌 */
  GET_BRAND_LIST: '/auth/brand/select',
  getUpdateItem: '/auth/product/lastUpdateTime',
  getCommentKeywords: '/auth/product/commentKeywords'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/consumerProducts.js